import marketFiltersMixin from '@/components/market/market-filters/market-filters-mixin/market-filters-mixin';

export default {
  mixins: [
    marketFiltersMixin,
  ],
  computed: {
    orderMenuName() {
      return this.selectedOrder.name;
    },
    mainClassName() {
      return 'market-filters-mobile';
    },
    orderButtonTheme() {
      return this.ordersOpen ? 'dark' : 'dark';
    },
    filtersButtonTheme() {
      return this.shouldShowTimespanFilter && !this.filtersOpen ? 'dark' : 'dark';
    },
    timespansButtonTheme() {
      return this.shouldShowTimespanFilter && !this.timespansOpen ? 'dark' : 'dark';
    },
    menuClassModifier() {
      return {
        'market-filters-mobile__menu': true,
        'market-filters-mobile__menu--with-timespan-filter': this.shouldShowTimespanFilter,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-filters/market-filters-mobile/market-filters-mobile.js